// // 测试
// const VUE_APP_WS_URL = 'ws://121.196.205.21:8080/websocket';
// const VUE_APP_BASEURL = 'http://121.196.205.21:8080';

// 正式
// const VUE_APP_WS_URL = 'wss://www.saxtrader.net/websocket';
// const VUE_APP_BASEURL = 'https://www.saxtrader.net';
// const VUE_APP_WS_URL = 'wss://www.galaxytrader.cloud/websocket';
// const VUE_APP_BASEURL = 'https://www.galaxytrader.cloud';
const VUE_APP_WS_URL = "wss://hjapi.caicai88888.top/websocket";
// const VUE_APP_BASEURL = "https://gear.khkjhkh.top";
// 测试
// const VUE_APP_WS_URL = "ws://192.168.0.132:8086/websocket"; //测试
const VUE_APP_BASEURL = "https://hjapi.caicai88888.top"; //测试
// const VUE_APP_BASEURL = "https://api.neexllc.cc";
// const VUE_APP_WS_URL = "wss://api.neexllc.cc/websocket";
// 本地
// const VUE_APP_BASEURL = 'https://u798377y57.zicp.fun';

export { VUE_APP_WS_URL, VUE_APP_BASEURL };
